import React from "react";
import PropTypes from 'prop-types';
import DirectChannel from "./DirectChannel";
import Popup from "reactjs-popup";
import {Scrollbar} from "react-scrollbars-custom";
import Decorator from "ui/common/channel/messages/message/Decorator";
import {connect} from "react-redux";

class DirectChannelWithPopup extends React.Component {

	constructor(props) {
		super(props);

		this.handleAvatarError = this.handleAvatarError.bind(this);
	}

	handleAvatarError(e) {
		e.target.src = this.props.configuration.baseDir + '/gfx/icons/user.png';
	}

	render() {
		const data = this.props.channel.infoWindow;

		return(
			<Popup
				trigger={ open => <DirectChannel open={ open } channel={ this.props.channel } highlighted={ this.props.highlighted } /> }
				position={ this.props.popupPosition }
				className={ "wcPopup wcInfoWindowPopup " + this.props.configuration.themeClassName }
				on={['hover', 'focus']}
				arrow={ false }
				keepTooltipInside={ this.props.keepInside }
			>
				<Scrollbar noScrollX={ true }>
					<div className="wcContent">
						{data.avatar &&
							<div className="wcLeft">
								<img src={ data.avatar } alt={ data.name } onError={ this.handleAvatarError } />
							</div>
						}
						<div className="wcRight">
							{data.url ? <a href={ data.url } rel="noopener noreferrer nofollow" className="wcName">{data.name}</a> : <span className="wcName">{data.name}</span>}
							<div className="wcDetails">
								<Decorator>{ data.content }</Decorator>
							</div>
						</div>
					</div>
				</Scrollbar>
			</Popup>
		)
	}

}

DirectChannelWithPopup.defaultProps = {
	popupPosition: "left center"
};

DirectChannelWithPopup.propTypes = {
	channel: PropTypes.object.isRequired,
	popupPosition: PropTypes.string.isRequired,
	highlighted: PropTypes.bool,
	keepInside: PropTypes.string
};

export default connect(
	(state) => ({
		configuration: state.configuration
	})
)(DirectChannelWithPopup);